import { MEDDICScores } from '@vendasta/sales-opportunities';

export function computeProgress(scores: MEDDICScores): number {
  if (!scores) {
    return 0;
  }
  const keys = Object.keys(scores);
  const max: number = keys.reduce((sum: number) => sum + 2, 0);
  const values = keys.map((k) => scores[k]);
  const score = values.reduce((sum, cur) => sum + cur);
  return score / max;
}

export function computeScoreSum(scores: MEDDICScores): number {
  if (!scores) {
    return 0;
  }
  const keys = Object.keys(scores);
  const values = keys.map((k) => scores[k]);
  return values.reduce((sum, cur) => sum + cur, 0);
}
